const settings = require('../../../../../js-handler/settings');
const labelSizes = ['default', '2.25x1.25', '3x2'];

export function getLabelSize() {
    try {
        const userSettings = JSON.parse(localStorage.getItem('settings') || 'null');
        const size = userSettings?.purchaseLabelSize;
        return labelSizes.includes(size) ? size : 'default';
    } catch (error) {
        return 'default';
    }
}

export function saveLabelSize(size) {
    if (!labelSizes.includes(size)) return;
    try {
        const userSettings = JSON.parse(localStorage.getItem('settings') || 'null');
        if (!userSettings) return;

        // Agrega el tamano al objeto existente sin reemplazar sus otros ajustes.
        userSettings.purchaseLabelSize = size;
        localStorage.setItem('settings', JSON.stringify(userSettings));

        // Mantiene actualizado el objeto de settings que el framework tiene en memoria.
        const currentSettings = settings.getData();
        if (currentSettings && currentSettings.id === userSettings.id &&
            currentSettings.company === userSettings.company) {
            currentSettings.purchaseLabelSize = size;
        }
    } catch (error) {
        console.warn('Purchase: no se pudo guardar el tamano del label.', error);
    }
}
